import { gql } from '@apollo/client';
import DEVICE_FRAGMENT from '../fragments/deviceFragment';

const QUICK_ACCESS_DEVICE_QUERY = gql`
  query quickAccessDevice($deviceId: String!) {
    quickAccessDevice(deviceId: $deviceId) {
      ...DeviceFragment
    }
  }

  ${DEVICE_FRAGMENT}
`;

export default QUICK_ACCESS_DEVICE_QUERY;
